module.exports = __webpack_public_path__ + "static/media/icon-display.b4af9341.svg";